import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import SqlJson from '../../components/BasePassword.vue';
export default {
  __name: 'BasePasswordPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "Base64加密 / Base64解密",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(SqlJson)]),
        _: 1
      });
    };
  }
};